import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Config } from '~/api/def/endpoints/dashboardEndpoint';

interface Dashboard {
  id: string;
  name: string;
  config: Config[];
  icon?: string;
}

export const showDeleteConfirmation = (
  dashboard: Dashboard,
  onDelete: (id: string) => void,
) => {
  confirmDialog({
    message: `Are you sure you want to delete "${dashboard.name}"?`,
    header: 'Delete Confirmation',
    icon: 'pi pi-exclamation-triangle',
    acceptClassName: 'p-button-danger',
    accept: () => onDelete(dashboard.id),
    reject: () => {
      // Optional: Handle rejection
    },
  });
};

export const DeleteDashboardDialog = () => {
  return <ConfirmDialog />;
};
